import { BadgeProps } from '@razorpay/blade/components';
import styled, { createGlobalStyle } from 'styled-components';

export const EventTimestampWrapper = styled.div<{ borderColor?: BadgeProps['color'] }>(
  ({ theme, borderColor }) => {
    return `
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing[1]}px;
        padding-left: ${theme.spacing[3]}px;
        padding-right: ${theme.spacing[3]}px;
        border-left: ${
          borderColor
            ? `${theme.border.width.thicker}px solid ${theme.colors.interactive.border[borderColor].default}`
            : 'none'
        };
    `;
  },
);

export const StyledPayrollProgressWrapper = styled.div(
  ({ theme }) => `
        background-color: ${theme.colors.interactive.background.gray.faded};
        border: ${theme.border.width.thinner}px solid ${theme.colors.surface.border.gray.muted};
        border-radius: ${theme.border.radius.medium}px;
        padding: ${theme.spacing[5]}px 0px 0px;
        overflow: hidden;
        margin-bottom: ${theme.spacing[7]}px;
    `,
);

export const StyledActionSummaryWrapper = styled.div(
  ({ theme }) => `
    background-color: ${theme.colors.surface.background.gray.intense};
    border-color: ${theme.colors.surface.border.gray.subtle};
    border-style: solid;
    border-width: ${theme.border.width.thin}px;
    border-left: none;
    border-top-right-radius: ${theme.border.radius.large}px;
    border-bottom-right-radius: ${theme.border.radius.large}px;
    padding: ${theme.spacing[5]}px;
    flex: 1;
  `,
);

export const ResetLocalOverridingStyles = styled.div(
  ({ theme }) => `
  button {
    height: unset;
    min-width: unset;
  }
  td {
    border-bottom: unset;
  }
  th:first-child {
    padding-left: unset;
  }
  td:first-child {
    padding-left: unset;
  }
  .wrapper__opfin-url input#subdomain, .wrapper__opfin-url input#subdomain span.underline, .wrapper__opfin-url p, .wrapper__opfin-url p span.underline, .wrapper__opfin-url p span.underline span.underline, h3, h3 span.underline, p{
    max-width: unset;
  }
  p {
    text-align: unset;
  }
  table th {
    background: unset !important;
    color: unset !important;
    font-size: unset !important;
    font-weight: unset !important;
    line-height: unset !important;
  }
`,
);

// Kept as styled-components global style: targets Blade's date-picker PORTAL
// (rendered outside our tree) and needs !important to beat legacy global CSS —
// neither is expressible via Blade props.
export const ResetBladePortalOverridingStyles = createGlobalStyle(
  ({ theme }) => `
  [role='dialog'][aria-labelledby^='datepicker-title-'] {
    width: fit-content !important;
    max-width: calc(100vw - ${theme.spacing[8]}px);
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] .DatePicker-header {
    display: none !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] .DatePicker-levelsGroup {
    width: max-content !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] table {
    width: auto !important;
    table-layout: auto !important;
    border-collapse: collapse;
    border: none !important;
    background: transparent !important;
    color: inherit !important;
    margin: 0 !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] thead,
  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] tbody,
  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] tr {
    border: none !important;
    background: transparent !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] td {
    border: none !important;
    background: transparent !important;
    display: table-cell !important;
    padding: 0 0 ${theme.spacing[1]}px !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] th {
    border: none !important;
    background: transparent !important;
    display: table-cell !important;
    padding: 0 0 ${theme.spacing[4]}px !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] [data-blade-component='calendar'] [data-celltype='day'] {
    width: ${theme.spacing[9]}px !important;
    height: ${theme.spacing[9]}px !important;
    min-width: ${theme.spacing[9]}px !important;
  }

  [role='dialog'][aria-labelledby^='datepicker-title-'] p {
    max-width: unset;
    text-align: unset;
  }
`,
);
